import parserUtils from './utils'
import { toNumber } from 'lodash'
import { Demographic } from '@node/wam-audience-builder'

export default {
    commitError: (commit, action, error) => {
        commit(
            action,
            {
                type: 'error',
                message: error.message
            },
            { root: true }
        )
        throw error
    },

    buildRoutes: () => {
        const route = '/audience_admin/bigsea_sociodemos.json'
        const params = {
            params: { list_limit: 0 }
        }
        return { route, params }
    },

    parseData: (data, countryCode2) => {
        const _data = []
        for (const val of data) {
            const wamData = {
                id: toNumber(val.id),
                label: val.sociodemo_label,
                display_order: toNumber(val.sociodemo_order),
                isSelectable: true,
                hasChild: false,
                parentJsonKeyName: parserUtils.getParentJsonKeyName(val.sociodemo_type),
                jsonKey: {
                    name: 'sociodemo_' + val.id,
                    type: 'Sociodemo',
                    subType: parserUtils.getJsonKeySubType(val.sociodemo_type),
                    ids: [toNumber(val.id), countryCode2]
                }
            }
            _data.push(wamData)
        }
        return _data.sort((a, b) => (a.display_order > b.display_order ? 1 : b.display_order > a.display_order ? -1 : 0))
    },

    instanciateAll: (demographicData, countryCode) => {
        const parents = [
            {
                id: 0,
                label: 'Age',
                subCategory: 'a',
                path: ['Third Party', 'Demographic'],
                selectable: false,
                parentId: null,
                countryCode
            },
            {
                id: 0,
                label: 'Education',
                subCategory: 'e',
                path: ['Third Party', 'Demographic'],
                selectable: false,
                parentId: null,
                countryCode
            },
            {
                id: 0,
                label: 'Gender',
                subCategory: 'g',
                path: ['Third Party', 'Demographic'],
                selectable: false,
                parentId: null,
                countryCode
            },
            {
                id: 0,
                label: 'Income',
                subCategory: 'i',
                path: ['Third Party', 'Demographic'],
                selectable: false,
                parentId: null,
                countryCode
            }
        ]
        return Demographic.createAll([
            ...parents,
            ...demographicData.map(demo => {
                return {
                    id: parseInt(demo.id),
                    label: demo.sociodemo_label,
                    displayOrder: demo.sociodemo_order,
                    path: ['Third Party', 'Demographic'],
                    parentId: Demographic.generateCrossId({
                        category: 'Demographic',
                        subCategory: demo.sociodemo_type,
                        id: 0
                    }),
                    subCategory: demo.sociodemo_type,
                    countryCode
                }
            })
        ])
    }
}
